export var GateType;
(function (GateType) {
    GateType["AND"] = "AND";
    GateType["NAND"] = "NAND";
    GateType["OR"] = "OR";
    GateType["GENERAL"] = "GENERAL";
})(GateType || (GateType = {}));
export var NodeType;
(function (NodeType) {
    NodeType["ACTUATOR"] = "actuator";
    NodeType["SENSOR"] = "sensor";
    NodeType["GATE"] = "gate";
    NodeType["MEMORY_BLOCK"] = "memoryBlock";
    NodeType["NOTE"] = "note";
})(NodeType || (NodeType = {}));
export var TriggerType;
(function (TriggerType) {
    TriggerType["STATES"] = "states";
    TriggerType["STATECHANGE"] = "stateChange";
    TriggerType["ALWAYS"] = "always";
    TriggerType["STATE_CHANGE_DECISION"] = "stateChangeDecision";
})(TriggerType || (TriggerType = {}));
//# sourceMappingURL=common.js.map